/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_lS as lS,
  rec_pS as pS,
} from "../../runtime/index.jsx";
export function Componente_aO_97_79(e) {
  return (
    <li
      key={e.id}
      className={`py-3 text-sm text-(--text-h)`}
      children={[
        <p
          children={[
            <strong
              children={e.actorNombre || `Usuario ${e.actorUsuarioId}`}
            />,
            ` · Tarea #`,
            e.tareaId,
            ` · `,
            lS(e.accion),
          ]}
        />,
        e.campo && (
          <p
            children={[
              e.campo,
              `: `,
              e.valorAntes ?? `Sin valor`,
              ` → `,
              e.valorDespues ?? `Sin valor`,
            ]}
          />
        ),
        e.detalle && <p children={e.detalle} />,
        <time className={`text-xs text-(--text)`} children={pS(e.en)} />,
      ]}
    />
  );
}
